import { FILTER_PATTERN_CHECK } from '../../config/settings/regexes'

/**
 * Compares the given value with the given pattern.
 *
 * E.g.
 *
 * const pattern = 'SOME_STRING_PATTERN'
 * const filteredOptions = options.filter(option => compareByPattern(option.name, pattern))
 */
export const compareByPattern = (value, pattern) => {
  value
    ?.toString()
    ?.toLowerCase()
    ?.normalize('NFD')
    ?.replace(FILTER_PATTERN_CHECK, '')
    ?.includes(pattern.toLowerCase().normalize('NFD').replace(FILTER_PATTERN_CHECK, ''))
}
